<template>
    <v-container class="py-7">
        <v-row>
            <v-col :cols="12">
                <div class="title-container">
                    <div class="title-block">
                        <span class="page-title">{{ page.title }}</span>
                        <v-breadcrumbs class="app-breadcrumb" divider="›" :items="dataset.breadcrumbItems"></v-breadcrumbs>
                    </div>
                    <div class="button-group">
                        <v-btn id="btnSave" type="button" elevation="0" color="primary" dark @click="add"
                            :loading="dataForm.addLoading" v-if="page.isNew && $check(user, ['clientdocs.create'])">Criar</v-btn>
                        <v-btn id="btnSave" type="button" elevation="0" color="primary" dark @click="update"
                            :loading="dataForm.updateLoading" v-if="!page.isNew && $check(user, ['clientdocs.update'])">Salvar</v-btn>
                        <v-btn id="btnBack" type="button" elevation="0" color="primary" outlined
                            to="/documentos">Voltar</v-btn>
                    </div>
                </div>
            </v-col>
        </v-row>

        <v-form ref="form" v-model="dataForm.validForm">
            <v-row>
                <v-col cols="12">
                    <v-row>
                        <v-col cols="12">
                            <v-card class="card-form-outlined">
                                <v-card-title class="card-group-title">Detalhes</v-card-title>
                                <v-card-text>
                                    <v-row>
                                        <v-col cols="12" sm="12">
                                            <v-text-field dense label="Nome" v-model="dataset.data.name" outlined
                                                hide-details="auto"
                                                :disabled="(!page.isNew && !($check(user, ['clientdocs.update'])))">
                                            </v-text-field>
                                        </v-col>
                                    </v-row> 
                                    
                                    <v-row>
                                        <v-col cols="12" sm="12">
                                            <v-autocomplete dense id="type" :items="dataset.clients" label="Caso"
                                                v-model="dataset.data.client_id" item-value="id" item-text="name" outlined
                                                hide-details="auto" no-data-text="Nenhum caso encontrado"
                                                :disabled="(!page.isNew && !($check(user, ['clientdocs.update'])))">
                                            </v-autocomplete>
                                        </v-col>
                                    </v-row>
                                    <v-row>

                                        <v-col cols="12" sm="6">
                                            <v-select dense id="type" :items="dataset.clientDocTypes" label="Tipo"
                                                v-model="dataset.data.type" item-value="id" item-text="name" outlined
                                                hide-details="auto"
                                                :disabled="(!page.isNew && !($check(user, ['clientdocs.update'])))">
                                            </v-select>
                                        </v-col>
                                        <v-col cols="12" sm="6">
                                            <v-text-field dense type="date" label="Data Protocolo"
                                                :value="formatDate(dataset.data.protocoled_at)" @input="protocolDate"
                                                outlined hide-details="auto"
                                                :disabled="(!page.isNew && !($check(user, ['clientdocs.update'])))">
                                            </v-text-field>
                                        </v-col>
                                    </v-row>
                                        
                                    <v-row>
                                        <v-col cols="12">
                                            <v-file-input dense accept="image/png, image/jpeg, application/pdf, .csv, application/vnd.ms-excel"
                                                prepend-icon="" outlined counter required show-size
                                                :rules="fileRules"
                                                hint="O arquivo não pode ser superior a 150MB" hide-details="auto"
                                                label="Documento" :clearable="true" @change="onFileSelected($event)"
                                                ref="logoFile"  truncate-length="70"
                                                :disabled="(!page.isNew && !($check(user, ['clientdocs.update'])))">
                                            </v-file-input>
                                        </v-col>
                                    </v-row>
                                    <!-- :rules="[$rules.required, $rules.fileSize(15)]" -->
                                    <template v-if="dataset.data.doc_url">
                                        <v-row class="mt-n5" >
                                            <v-col class="doc-info">
                                            <span >Documento atual</span>  
                                            </v-col>
                                        </v-row> 
                                        <v-row class="mt-n3">
                                            <v-col>  
                                                <iframe
                                                    :src="dataset.data.doc_url"
                                                    width="250"
                                                    height="150"
                                                    frameborder="0"
                                                    scrolling="no" class="rounded-xl"
                                                ></iframe>

                                            </v-col>
                                        </v-row>
                                        <v-row>
                                            <v-col cols="12">
                                                <v-btn type="button" elevation="0" color="primary" outlined :href="dataset.data.doc_url"
                                                    target="_blank">Visualizar documento
                                                </v-btn> 
                                            </v-col>
                                        </v-row>
                                    </template>
                                </v-card-text>
                            </v-card>
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>
        </v-form>

    </v-container>
</template>

<script>
import states from "@/common/data/states.data"
import clientDocTypes from "@/common/data/client-doc-types.data"
import string from "@/common/util/string"

import axios from "axios"

export default {
    name: "ClientDocDetails",

    data: () => ({
        user: null,
        page: {
            isNew: false,
            title: "",
        },
        dataset: {
            clientDocTypes: clientDocTypes,
            clients: [],
            breadcrumbItems: [],
            data: {
                category_id: null
            },
        },
        dataForm: {
            validForm: true,
            addLoading: false,
            updateLoading: false,
            removeLoading: false,
            showPassword: false,
            showPasswordConfirmation: false,
        },
    }),

    created() {
        this.loadData();
    },

    computed: {
        fileRules() {
            const rules = [];
            if (!this.dataset.data.doc_url) {
                
                rules.push(this.$rules.required);
            }
            rules.push(this.$rules.fileSize(150));
            return rules;
        },
    },

    methods: {
        goBack() {
            this.$router.replace("/documentos");
        },

        setPage() {
            this.page.isNew = this.$route.params.id === "novo";
            this.page.title = `${this.page.isNew ? 'Novo documento' : 'Detalhes do documento'}`;
        },

        formatDate(date) {
            if (!date || date === "0000-00-00 00:00:00") return null;
            return this.$moment(date).format('YYYY-MM-DD');
        },

        protocolDate(value) {
            this.dataset.data.protocoled_at = value;
        },

        openDoc(doc) {
            this.selectedDoc = doc;
            this.dialogViewDoc = true;
        },

        async loadData() {
            this.user = this.$root.user.data || this.$root.user;

            this.setPage();
            this.listBreadCrumbItems();

            await this.loadClients()
            await this.load();

        },

        listBreadCrumbItems() {
            this.dataset.breadcrumbItems = [
                {
                    text: "Homepage",
                    disabled: false,
                    to: "/home",
                    exact: true,
                },
            ];

            this.dataset.breadcrumbItems.push({
                text: "Documentos",
                disabled: false,
                to: "/documentos",
                exact: true,
            })

            this.dataset.breadcrumbItems.push({
                text: this.page.title,
                disabled: true,
                exact: true,
            });
        },

        async load() {

            if (this.page.isNew) return;

            try {
                const result = await axios.get(`/api/admin/client-docs/${this.$route.params.id}`);
         
                const data = result.data.content.data;

                this.dataset.data = data;

            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 2000
                })
            }
        },

        async loadClients() {

            try {
                const result = await axios.get(`/api/clients`, { params: { start: 1, limit: 100000, search: {} } });

                this.dataset.clients = result.data.content.data;

                this.dataset.clients.sort((a, b) => a.name.localeCompare(b.name));

            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 2000
                })
            }
        },

        async add() {
            if (!this.$refs.form.validate()) return;

            const proceedAction = await this.$dialog.confirm({
                text: 'Deseja incluir o documento?',
                title: 'Incluir documento',
                actions: {
                    false: 'Cancelar',
                    true: 'Salvar'
                }
            })

            if (!proceedAction) return;

            this.dataForm.addLoading = true;

            const payload = this.buildPayload();

            try {
                const response = await axios.post('/api/admin/client-docs', payload);

                this.$dialog.notify.info("Documento salvo com sucesso", { position: "top-right", timeout: 2000 });

                this.goBack()
            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 2000
                })
            } finally {
                this.dataForm.addLoading = false;
            }

        },

        async update() {
            if (!this.$refs.form.validate()) return;

            const proceedAction = await this.$dialog.confirm({
                text: 'Deseja atualizar o documento?',
                title: 'Atualizar documento',
                actions: {
                    false: 'Cancelar',
                    true: 'Atualizar'
                }
            })

            if (!proceedAction) return;

            this.dataForm.addLoading = true;

            const payload = this.buildPayload();

            try {
                const response = await axios.patch(`/api/admin/client-docs/${this.$route.params.id}`, payload);

                this.$dialog.notify.info("Documento salvo com sucesso", { position: "top-right", timeout: 2000 });

                this.goBack()
            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 2000
                })
            } finally {
                this.dataForm.addLoading = false;
            }
        },

        onFileSelected(file) {
            this.dataset.data.file = file;
        },

        buildPayload() {
            const formData = new FormData()

            if (this.dataset.data.name)
                formData.append('name', this.dataset.data.name);

            if (this.dataset.data.type)
                formData.append('type', this.dataset.data.type);

            if (this.dataset.data.client_id)
                formData.append('client_id', this.dataset.data.client_id);

            if (this.dataset.data.client_id)
                formData.append('protocoled_at', this.dataset.data.protocoled_at);

            if (this.dataset.data.file)
                formData.append('file', this.dataset.data.file)

            return formData;
        },

    },
};
</script>

<style lang="scss">
.access-container {
    border: 1px solid var(--v-gray-base) !important;
}

.custom-chip {
    background: var(--v-white-base) !important;
}

.title-page {
    color: var(--v-primary-base);
    // font-family: Montserrat;
    font-size: 40px;
    font-style: normal;
    font-weight: 700;
    line-height: 38px;
}

.doc-info{
    color: var(--v-primary-base);
    font-size: 16px;
    font-style: normal;
}

.section-info-title {
    color: var(--v-primary-base);
    // font-family: Montserrat;
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
}

.section-info-value {
    // font-family: Montserrat;
    font-size: 14px;
    font-style: normal;
}
</style>